import {AppBar, Box, styled} from "@mui/material";
import {ImgBox} from "@/styles/layout/boxes";
import {mobileBigCssScreen, tabletCssScreen} from "@/utils/themeCssBreakpoints";


export const MobileHeaderAppBar = styled(AppBar)(({theme}) => ({
    position: 'fixed',
    padding: '3rem 0',
    transition: '0.3s',
    zIndex: 1100,
    backgroundColor: '#fff',
    boxShadow: 'none',

    '&.home': {
        backgroundColor: '#5663F4',
    },

    '& .MuiToolbar-root': {
        display: 'flex',
        justifyContent: 'space-between',
        minHeight: 'unset',
        maxWidth: '134rem',
        width: '90%',
        margin: '0 auto',

        [theme.breakpoints.down('sm')]: {
            padding: 0,
        },
    }

}))

export const MobileHeaderLogo = styled(ImgBox)(({theme}) => ({
    height: '2rem',
    width: '10rem',
    opacity: 1,
    cursor: 'pointer',

    [theme.breakpoints.down('sm')]: {
        height: '2.5rem',
    },
}))


export const BurgerButton = styled(Box)`
  display: none;
  height: 1.9rem;
  width: 1.9rem;
  position: relative;
  cursor: pointer;

  ${tabletCssScreen} {
    display: block;
  }

  b {
    position: absolute;
    width: 2.5rem;
    height: 0.2rem;
    background-color: #0B0A1A;

    &:nth-of-type(1) {
      top: 0;
    }

    &:nth-of-type(2) {
      top: 50%;
    }

    &:nth-of-type(3) {
      top: 100%;
    }
  }
  
  &.home {
    b {
        background-color: #FFFFFF;
    }
  }

    // ${mobileBigCssScreen} {
  //   width: 15px;
  //   height: 15px;
  //   margin-right: 1rem;
  //   b {
  //     width: 20px;
  //   }
  //}

  &.home {
    b {
      background-color: #FFFFFF;
    }
  }

  &.float {
    margin-right: 5rem;
  }
`;